import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid #ccc;
  width: 100vw;
  position: fixed;
  background-color: #f0f0f7;
  height: 6rem;  

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 1100px) {
    display: none;    
  }
`;

export const HorizontalMenuItem = styled.div`  
  padding: 2rem;
  display: inline-block;
  
`;

export const CategoryButton = styled.button`
  font-size: 2rem;
  border: 0;
  color: #b8b5ba;
  white-space: nowrap;
  background-color: unset;
  padding-bottom: 1rem;
  font-weight: 600;
  outline: none;
  transition: color 0.5s;

  ${props => props.active && css`
     border-bottom: 2px solid #9a6dad; 
     color: #9a6dad;      
    `
  }
`;